import { Container, Spacer } from '@loomhq/lens';
import React from 'react';

export default function Divider() {
  return (
    <Spacer y="large">
      <Container borderColor="border" borderSide="bottom" />
    </Spacer>
  );
}
